import {PartialFeature} from '../../../components/feature-view';

/** плашка «Подкласс Барда» в таблице: вместо неё встают особенности выбранного подкласса */
export function isSubClassPlaceholder(feature: PartialFeature) {
	// без \b: у кириллицы он не срабатывает
	return /^Подкласс(\s|$)/i.test(feature.title || '');
}

function firstLevel(feature: PartialFeature) {
	const levels = (feature.levels || [])
		.map((level) => parseInt(level, 10))
		.filter((level) => !Number.isNaN(level));
	return levels.length ? Math.min(...levels) : Number.MAX_SAFE_INTEGER;
}

/**
 * Особенности класса с подмешанными особенностями выбранного подкласса: плашка подкласса уходит,
 * а особенности подкласса встают по своему уровню, среди ровесников — по алфавиту. Порядок
 * остальных особенностей не трогаем: он задан книгой.
 */
export function withSubClassFeatures(features: PartialFeature[], subClassFeatures: PartialFeature[]) {
	if (!subClassFeatures.length) return features;

	const result = features.filter((feature) => !isSubClassPlaceholder(feature));
	const added = [...subClassFeatures].sort(
		(first, second) =>
			firstLevel(first) - firstLevel(second) || (first.title || '').localeCompare(second.title || '', 'ru'),
	);

	for (const feature of added) {
		const level = firstLevel(feature);
		const title = feature.title || '';
		const index = result.findIndex((item) => {
			const itemLevel = firstLevel(item);
			return itemLevel > level || (itemLevel === level && (item.title || '').localeCompare(title, 'ru') > 0);
		});
		if (index === -1) result.push(feature);
		else result.splice(index, 0, feature);
	}

	return result;
}
